<template>
  <div class="tpl">
    <van-nav-bar title="商户店铺" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <vue-swpier :items="slide" autoplay="5000"></vue-swpier>
    <van-divider :style="{ borderColor: '#888888', padding: '0 16px' }">店铺产品</van-divider>
    <!-- <div
      class="merchant"
      style="background-color:#fff;margin:10px 0 10px 0; padding:10px; display:flex"
    >
      <div
        style="line-height:30px; border-right: 1px solid #b2b2b2; padding-right:30px; font-size:16px"
      >
        <div>
          <van-icon name="shop-collect" color="red" style="padding-right:10px" />商户信息：
        </div>
        <div>名称：{{merchant.merchant_name}}</div> -->
        <!-- <div>{{item.merchant.address}}</div> -->
        <!-- <div>
          <van-icon name="location-o" style="padding-right:10px" />
          {{merchant.address}}
        </div>
      </div>
      <div style="flex-grow:1; text-align:center">
        <van-image src="http://yijia.sihandbms.cn/upload/goshop/20190924/7d085b8c0c3f8ed183e8d6a17d68d13b.jpg" style="width:100px; height:100px;" />
      </div>
    </div> -->

    <div class="goods">
      <van-list
        class="goodsList"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getGoodsList"
      >
        <!-- <van-cell v-for="item in goodsList" :key="item" :title="item.post_title" /> -->
        <router-link
          :to="'/shop/detail/'+item.id"
          class="item"
          v-for="item in goodsList"
          :key="item.id"
        >
          <van-image width="100%" height="50vw" fit="contain" :src="GLOBAL.IMG + item.thumbnail" />
          <div class="title">{{item.post_title}}</div>
          <div class="price">¥ {{item.price}}</div>
        </router-link>
      </van-list>
    </div>
  </div>
</template>
<script>
import vueSwpier from "@/components/vueSwiper.vue";
import Vue from "vue";
import { Divider } from "vant";

Vue.use(Divider);
export default {
  name: "goodsList",
  components: {
    vueSwpier
  },
  data() {
    return {
      slide: [],
      goodsList: [],
      loading: false,
      finished: false,
      cPage: 1,
      id: this.$route.params.id,
      merchant: {}
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getSlide(id) {
      this.$http
        .get(this.GLOBAL.API + "s_slide/index/slide?id=" + id, {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.slide = data.data;
          }
        });
    },
    getMerchant() {
      this.$http
        .get(this.GLOBAL.API + "s_merchant/merchant/index", {
          params: {
            merchantId: this.id
          },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.merchant = data.data;
          }
        });
    },

    getGoodsList() {
      this.$http
        .get(this.GLOBAL.API + "s_merchant/merchant/goodsList", {
          params: {
            merchantId: this.id,
            page: this.cPage
          },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.goodsList = this.goodsList.concat(data.data.data); //= data.data.data;
          }
        });
    }
  },

  mounted() {
    this.getMerchant();
    this.getSlide(5);
  }
};
</script>
<style lang="scss" scoped>
.tpl {
  text-align: left;
  background-color: #f6f6f6;
}
.van-sidebar-item--select {
  color: brown;
}
.goodsList {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  .item {
    margin-top: 5px;
    background-color: #ffffff;
    width: 49.5%;
    .title {
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0 5px 0 5px;
      color: #222333;
    }
    .price {
      color: red;
      text-align: left;
      padding: 0 5px 0 5px;
    }
  }
}
</style>